import { has, trim, isEmpty, isNil } from 'lodash';
import { ROUTE_OAUTH_1A_AUTH } from '../constants/pathnames';
import { getCurrentUtcTime } from '../lib/DateUtils';
import { CORS_URL } from '../constants/config';

import querystring from 'query-string';
import { getCorsCompatibleURL } from '../lib/URLUtils';

const AUTH_URL_PARAMS_FIELD = 'oauth1.auth_url.auth_url_params';
const REQ_URL_PARAMS_FIELD = 'oauth1.request_url.req_url_params';
const TOKEN_URL_PARAMS_FIELD = 'oauth1.token_url.token_url_params';

const OAuth = require('./utils/oauth');

const REDIRECT_URI = window.location.protocol + '//' + window.location.host + ROUTE_OAUTH_1A_AUTH;

function authenticate(fn, credInfo) {
  const oauth_secrets = {};
  window.HandlePopupResult = function (authResponse, error) {
    delete window.HandlePopupResult;

    let accessError = null;

    if (error) {
      accessError = error;
    } else if (has(authResponse, 'error')) {
      accessError = {
        code: authResponse.error,
        description: has(authResponse, 'error_description')
          ? authResponse.error_description
          : authResponse.error,
      };
    } else if (has(authResponse, 'access_token')) {
      fn({ ...authResponse, authorizedAt: getCurrentUtcTime() });
    } else if (has(authResponse, 'oauth_token')) {
      const oauth_verifier = has(authResponse, 'oauth_verifier')
        ? authResponse.oauth_verifier
        : null;
      const tokenSecret = oauth_secrets[authResponse.oauth_token];

      const extraAccessParamsString = !isNil(credInfo[TOKEN_URL_PARAMS_FIELD])
        ? trim(credInfo[TOKEN_URL_PARAMS_FIELD])
        : null;
      let extraAccessParamsObject = {};
      if (!isNil(extraAccessParamsString) && !isEmpty(extraAccessParamsString)) {
        extraAccessParamsObject = {
          ...querystring.parse(extraAccessParamsString),
        };
      }

      oa.getOAuthAccessToken(
        authResponse.oauth_token,
        tokenSecret,
        oauth_verifier,
        extraAccessParamsObject,
        function (error, oAuthAccessToken, oAuthAccessTokenSecret, results) {
          if (error) {
            fn(null, {
              message: 'Error occured while getting access token',
              error: error,
            });
            return;
          }

          fn({
            access_token: oAuthAccessToken,
            oauth_token_secret: oAuthAccessTokenSecret,
            authorizedAt: getCurrentUtcTime(),
          });
        },
      );
    }
    if (accessError) {
      fn(null, accessError);
    }
  };

  const credReqUrl = !isNil(credInfo, 'oauth1.request.url') ? credInfo['oauth1.request.url'] : '';
  const requestUrlParam = getCorsCompatibleURL(credReqUrl);

  const authorizeUrlParam = credInfo['oauth1.auth.url'];

  const credAccessUrl = !isNil(credInfo, 'oauth1.token.url') ? credInfo['oauth1.token.url'] : '';

  const accessUrlParam = getCorsCompatibleURL(credAccessUrl);

  const consumerKey = credInfo['oauth1.consumer.key'];
  const secretKey = credInfo['oauth1.consumer.secret'];

  const oa = getOauthObject(requestUrlParam, accessUrlParam, consumerKey, secretKey);

  // TODO: if this statement doesn't have a side-effect, it should be removed
  // eslint-disable-next-line
  const requestHeader = oa.authHeader(
    requestUrlParam + `?oauth_callack=${REDIRECT_URI}`,
    null,
    null,
    'POST',
  );

  const extraRequestParamsString = !isNil(credInfo[REQ_URL_PARAMS_FIELD])
    ? trim(credInfo[REQ_URL_PARAMS_FIELD])
    : null;
  let extraRequestParamsObject = {};
  if (!isNil(extraRequestParamsString) && !isEmpty(extraRequestParamsString)) {
    extraRequestParamsObject = {
      ...querystring.parse(extraRequestParamsString),
    };
  }
  //request_url_params_field
  oa.getOAuthRequestToken(
    extraRequestParamsObject,
    function (error, oAuthToken, oAuthTokenSecret, results) {
      oauth_secrets[oAuthToken] = oAuthTokenSecret;

      const authorizeUrl = authorizeUrlParam;
      const extraAuthParams = !isNil(credInfo[AUTH_URL_PARAMS_FIELD])
        ? credInfo[AUTH_URL_PARAMS_FIELD]
        : null;

      window.open(
        authorizeUrl +
          (authorizeUrl.includes('?') ? '&' : '?') +
          `oauth_token=${oAuthToken}` +
          (extraAuthParams ? `&${extraAuthParams}` : ''),
        'Authorization',
        'top=300,left=250,height=600,width=600',
      );
    },
  );
}

function getOauthObject(requestUrl, accessUrl, consumerKey, consumerSecret) {
  const oa = new OAuth.OAuth(
    requestUrl,
    accessUrl,
    consumerKey,
    consumerSecret,
    '1.0',
    REDIRECT_URI,
    'HMAC-SHA1',
    CORS_URL, //needs fully formatted CORS URL (  public_url + /cors/)
  );

  return oa;
}

export default { authenticate };
